import ipfs from '../Ipfs.js';
import {web3} from '../web3.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {SCRIPTS} from 'decentralized/transactions/contracts.js';
import EthereumTransaction from "decentralized/transactions/EthereumTransaction.js";
import {NewScript} from 'decentralized/EthereumEvents.js';
import ScriptsContract from 'decentralized/contracts/ScriptsContract.js';
import BackendQuery from 'decentralized/BackendQuery.js';

export const newScript = async (scriptText, type, title) => {
    let packHash = await ipfs.addJson(scriptText);

    await new EthereumTransaction(
        SCRIPTS,
        'newScript',
        [
            ipfsHashToBytes32(packHash),
            web3.utils.fromAscii(type),
            web3.utils.fromAscii(title),
        ])
        .execute();
};

export const getScripts = async (scriptType) => {
    let query = new BackendQuery(new ScriptsContract().contractAddress)
        .select("scriptHash")
        .select("scriptType")
        .select("title")
        .where("scriptType", scriptType)
        .from(NewScript);
    let results = await query.executeQuery();
    return results;
};

let CODE_CACHE = {};
export const getScriptForTitleSync = (title) => {
    if (title in CODE_CACHE) {
        return CODE_CACHE[title];
    } else {
        getScriptForTitle(title);
    }
    return '';
};

export const getScriptForTitle = async (title) => {
    if (title in CODE_CACHE) {
        return CODE_CACHE[title];
    }
    let query = new BackendQuery(new ScriptsContract().contractAddress)
        .select("scriptHash")
       .from(NewScript)
       .where('title', title);
    let results = await query.executeQuery();
    if (results[0]) {
        let json = await ipfs.getJson(results[0].scriptHash);
        CODE_CACHE[title] = json;
        return json;
    }
    return undefined;
};

window.getScripts = getScripts;
window.getScriptForTitle = getScriptForTitle;
